module.exports = __webpack_public_path__ + "static/media/home1.8909247e.webp";